/**
 * Simple helper for Questions
 */
export default {
  name: 'Question',
  methods: {
    indexToLetter(num) {
      return this.abc[num];
    },
  },
  data() {
    return {
      abc: ['1', '2', '3', '4', '5', 'F', 'G', 'H', 'I', 'J', 'K', 'L'],
    };
  },
};
